import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { TimeOff } from "@hubcapp/types";

import createTimeOffMutation from "../graph-ql/createTimeOff.graphql";

const useMutationCreateTimeOff = (
  opts: MutationHookOptions<{
    createTimeOff: TimeOff;
  }> = {},
) =>
  useMutation(createTimeOffMutation, {
    ...opts,
  });

export default useMutationCreateTimeOff;
